// https://www.npmjs.com/package/rc-table
import React from 'react'
import Pagination, { PaginationProps as RcPaginationProps } from 'rc-pagination'
import styled from 'styled-components'
import Icon from '../Icon'

// 强制转换类组件的类型
const PaginationJSX = Pagination as unknown as React.FC<RcPaginationProps>

const PaginationLayout = styled.div`
  width: 100%;
  .ex-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    &-item {
      font-size: 14px;
      line-height: 18px;
      padding: 0 10px;
      color: #A3A3A3;
      min-width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 8px;
      background: #1A1919;
      border: 1px solid #3A3939;
      border-radius: 3px;
      cursor: pointer;
      &-active {
        background: #E0C286;
        color: #090808;
      }
    }
    &-jump-next span,
    &-jump-prev span {
      margin: 0 14px;
      color: #A3A3A3;
      font-size: 20px;
      cursor: pointer;
    }
    &-prev {
      margin-right: 10px;
    }
    &-next {
      margin-left: 10px;
    }
    &-next,
    &-prev {
      opacity: 0.8;
      cursor: pointer;
      color: #A3A3A3;
    }
    &-disabled * {
      cursor: not-allowed;
      opacity: 0.7;
    }
    .more {
      display: inline-block;
      transform: translateY(-5px);
    }
  }
`

export interface PaginationProps extends RcPaginationProps {
  size?: 'default' | 'small'
  responsive?: boolean
  role?: string
  totalBoundaryShowSizeChanger?: number
  onPageChange?: (page: number, pageSize: number) => void
}

export default function CustomPagination(props: PaginationProps) {
  const { onPageChange, ...rest } = props
  return (
    <PaginationLayout>
      <PaginationJSX
        prevIcon={<Icon type="left" />}
        nextIcon={<Icon type="right" />}
        jumpPrevIcon={<span className="more">...</span>}
        jumpNextIcon={<span className="more">...</span>}
        {...rest}
        prefixCls="ex-pagination"
        onChange={onPageChange}
      />
    </PaginationLayout>
  )
}
